import { Claim } from "./claim";

export class Token {
    claims: Claim[];
    issuedAtTime: number;
    notValidBeforeTime: number;
    expirationTime: number;
}
